import { render } from "./Guide.vue?vue&type=template&id=65465586&scoped=true&ts=true"
import script from "./Guide.vue?vue&type=script&lang=ts"
export * from "./Guide.vue?vue&type=script&lang=ts"

import "./Guide.vue?vue&type=style&index=0&id=65465586&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65465586"]])

export default __exports__